import { Product } from './product';
import { ProductCategory } from './product-category';

export class ProductLayout {
  public id: number;
  public name: string;
  public description: string;
  public products: Array<Product>;
  public image: string;
  public visible: boolean;
  public category: ProductCategory;
  public relativeImage: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  public getName(): string {
    if (this.isShortCutCategory()) {
      return this.name;
    } else {
      return this.category.name;
    }
  }

  public getProducts(): Array<Product> {
    if (this.isShortCutCategory()) {
      return this.products;
    } else {
      return this.category.products;
    }
  }

  public getImage(): string {
    const image: string = this.isShortCutCategory()
      ? this.relativeImage
      : this.category.relativeImage;
    if (/\//.test(image)) {
      return '/' + image;
    } else {
      return 'assets/img/category/' + image;
    }
  }

  public getId(): number {
    if (this.isShortCutCategory()) {
      return this.id;
    } else {
      return this.category.id;
    }
  }

  public isVisible(): boolean {
    if (this.isShortCutCategory()) {
      return this.visible;
    } else {
      return this.category.visible;
    }
  }

  public isShortCutCategory(): boolean {
    return this.id > 0 && typeof this.category === 'undefined';
  }
}
